import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { GenericObject, PaymentTypes } from "@/utils/types";

export type FormStore = {
  saleId: number | null;
  eligibilityToken: string | null;
  value: {
    address: {
      zipCode: string;
      street: string;
      neighborhood: string;
      number: string;
      complement: string;
      stateCode: string;
      cityName: string;
      referencePoint: string;
      noNumber: boolean;

      [key: string]: unknown;
    };
    payment: {
      dueYear: string;
      dueDate: string;
      dueMonth: string;
      securityCode: string;
      creditCard: string;
      mainName: string;
      bank: string;
      agency: string;
      account: string;
      debtDueDate: string;
      knownClausules: boolean;
      knownTerms: boolean;
    };
    cpf: string;
    birthDate: string;
    email: string;
    ofertaSlug: string;
    fullName: string;
    motherName: string;
    paymentType: { type: string; value: PaymentTypes; label: string } | null;
    tel: string;
    autorizarContato: boolean;
    tipo: string;
    utm_campaign: string;
    utm_medium: string;
    utm_source: string;
    uuid: string;
    retomado: boolean;
    found: boolean;
    possuiProvisorio: number | null;
    [key: string]: unknown;
  };
  addData(payload: GenericObject): void;
  setEligibilityToken(token: string): void;
  setSaleId(saleId: number): void;
  clearFormStore(): void;
  isMigration(): boolean;
  isNewLine(): boolean;
  isPortability(): boolean;

  saleBody: GenericObject | null;
  setSaleBody(saleBody: GenericObject): void;
};

const defaultValue = {
  cpf: "",
  birthDate: "",
  email: "",
  ofertaSlug: "",
  fullName: "",
  motherName: "",
  paymentType: null,
  tel: "",
  autorizarContato: true,
  tipo: "MIGRACAO",
  utm_campaign: "",
  utm_medium: "",
  utm_source: "",
  uuid: "",
  found: false,
  retomado: false,
  possuiProvisorio: 1,
  address: {
    zipCode: "",
    street: "",
    neighborhood: "",
    number: "",
    complement: "",
    cityName: "",
    stateCode: "",
    referencePoint: "",
    noNumber: false,
  },
  payment: {
    dueYear: "",
    dueMonth: "",
    dueDate: "",
    securityCode: "",
    creditCard: "",
    mainName: "",
    bank: "",
    agency: "",
    account: "",
    debtDueDate: "",
    knownClausules: true,
    knownTerms: true,
  },
};

export const useFormStore = create<FormStore>()(
  persist(
    (set, get) => ({
      eligibilityToken: null,
      setEligibilityToken(token) {
        set((state) => ({ ...state, eligibilityToken: token }));
      },

      saleId: null,
      setSaleId(saleId) {
        set((state) => ({ ...state, saleId }));
      },

      saleBody: null,
      setSaleBody(saleBody) {
        set((state) => ({ ...state, saleBody }));
      },

      value: defaultValue,
      addData(payload: GenericObject) {
        set((state) => ({ ...state, value: { ...state.value, ...payload } }));
      },
      clearFormStore() {
        set((state) => ({
          ...state,
          order: null,
          eligibilityToken: null,
          saleId: null,
          saleBody: null,
          value: defaultValue,
        }));
      },
      isMigration() {
        return get().value.tipo === "MIGRACAO";
      },
      isNewLine() {
        return get().value.tipo === "NOVA_LINHA";
      },
      isPortability() {
        return get().value.tipo === "PORTABILIDADE";
      },
    }),
    {
      name: "form-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        value: {
          ...state.value,
          payment: undefined,
        },
        saleId: state.saleId,
        eligibilityToken: state.eligibilityToken,
        saleBody: state.saleBody,
      }),
    },
  ),
);
